// extracted by mini-css-extract-plugin
export default {"navFooter":"navFooter","iconRow":"iconRow","iconChip":"iconChip","popCard":"popCard","popTitle":"popTitle","popDesc":"popDesc"};